export interface OperationState {
  loading: boolean
  error: string | null
}

export const initialOperationState: OperationState = {
  loading: false,
  error: null
}

export interface AccountSettingsContextValue {
  displayName: OperationState
  email: OperationState
  password: OperationState
  addPassword: OperationState
  deleteAccount: OperationState
  removePhoto: OperationState
  uploadPhoto: OperationState
  // Every action resolves to whether it worked, so callers never have to read operation state
  // back after awaiting — the value they'd read is a render behind.
  updateDisplayName(name: string): Promise<boolean>
  updateEmail(newEmail: string, currentPassword: string): Promise<boolean>
  updatePassword(currentPassword: string, newPassword: string): Promise<boolean>
  addPasswordFn(newPassword: string): Promise<boolean>
  /**
   * The only operation here that returns more than success: the survey token, which the caller has
   * to carry to the post-deletion page because the session it was issued to is about to end.
   * `false` on failure, matching the boolean the others return.
   */
  deleteAccountFn(): Promise<string | null | false>
  removePhotoFn(): Promise<boolean>
  uploadPhotoFn(blob: Blob): Promise<boolean>
  clearAllErrors(): void
}
